import React, { useEffect, useState } from "react";
import "../general.css";
import "./Login.css";
import logo from "../assets/logo.png";
import { login } from "../Firebase/upload";
import Loading from "../Pages/Loading";
import navigation from "../Auth/Navigation";

const Login = () => {
  const MainHome = sessionStorage.getItem("MainHome");
  const tag = sessionStorage.getItem("UserType");

  window.onload = function () {
    if (MainHome !== null && tag !== null) {
      window.location.href = MainHome;
    } else if (tag !== null && MainHome === null) {
      navigation("/login");
    } else {
      navigation("/");
    }
  };

  const [formErrors, setFormErrors] = useState({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [user, setUserDetails] = useState({
    email: "",
    password: "",
  });

  const changeHandler = (e) => {
    setIsError(false);
    const { name, value } = e.target;
    setUserDetails({
      ...user,
      [name]: value,
    });
  };

  useEffect(() => {});
  const validateForm = (values) => {
    const error = {};
    const regex = /^[^\s+@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.email) {
      error.email = "Email is required";
    } else if (!regex.test(values.email)) {
      error.email = "Please enter a valid email address";
    }
    if (!values.password) {
      error.password = "Password is required";
    }
    return error;
  };

  const loginHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setFormErrors(validateForm(user));
    if (user.email.trim().length !== 0 && user.password.trim().length !== 0) {
      let log = await login(user.email, tag, user.password);
      sessionStorage.setItem("UserMail", user.email);
      setIsError(log);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const hideHandle = () => {
    sessionStorage.clear();
    navigation("/");
  };

  return (
    <div className="main" style={{ minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)' }}>
      {isLoading && <Loading />}
      <div className="login-card Content-Background" style={{ maxWidth: 420, width: '100%', margin: '0 auto', padding: '2.5rem 2rem', borderRadius: '1.5rem', boxShadow: '0 10px 32px rgba(30,64,175,0.10)' }}>
        <div className="Header" style={{ justifyContent: 'center', marginBottom: '2rem', background: 'none', boxShadow: 'none', padding: 0 }}>
          <img src={logo} alt="University Logo" className="Logo" style={{ margin: '0 auto' }} />
        </div>
        <div className="title" style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '1.5rem', color: '#1e40af' }}>VIT Document Approval System</div>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#64748b', fontWeight: 500, fontSize: '1.1rem' }}>
          Login as <span style={{ color: '#1e40af', fontWeight: 700 }}>{tag}</span>
        </div>
        <span id="Strong" onClick={hideHandle} title="Back to Home" style={{ position: 'absolute', top: 24, right: 32, cursor: 'pointer', color: '#ef4444', fontWeight: 700, fontSize: '1.5rem' }}>×</span>
        {isError && (
          <div className="alert alert-danger" style={{ marginBottom: '1rem', fontSize: '1rem', color: '#ef4444', background: '#fef2f2', borderRadius: 8, padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" /></svg>
            <span>Invalid Password or Email!</span>
          </div>
        )}
        <form className="form" style={{ width: '100%' }} autoComplete="off">
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              className="form-input"
              type="email"
              name="email"
              placeholder="Email"
              onChange={changeHandler}
              value={user.email}
              required
              style={{ fontSize: '1rem', padding: '0.9rem', border: '1.5px solid #cbd5e1', borderRadius: 10, width: '100%' }}
            />
            {formErrors.email && <div className="error" style={{ color: '#ef4444', fontSize: '0.95rem', marginTop: 4 }}>{formErrors.email}</div>}
          </div>
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              className="form-input"
              type="password"
              name="password"
              placeholder="Password"
              onChange={changeHandler}
              value={user.password}
              required
              style={{ fontSize: '1rem', padding: '0.9rem', border: '1.5px solid #cbd5e1', borderRadius: 10, width: '100%' }}
            />
            {formErrors.password && <div className="error" style={{ color: '#ef4444', fontSize: '0.95rem', marginTop: 4 }}>{formErrors.password}</div>}
          </div>
          <button
            className="dashboard-button primary-button"
            style={{ width: '100%', padding: '0.9rem', fontSize: '1.1rem', fontWeight: 600, borderRadius: 10, background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)', color: '#fff', border: 'none', marginTop: 8, marginBottom: 8 }}
            onClick={loginHandler}
          >
            Login
          </button>
        </form>
        <div className="footer-credit" style={{ textAlign: 'center', marginTop: '2rem', color: '#64748b', fontWeight: 500 }}>
          Developed by GARV ANAND
        </div>
      </div>
    </div>
  );
};
export default Login;
